export const SSR = {
  label: 'Server-Side Application',
  value: 'ssr',
  tabs: ['branding', 'integrations'],
}
